import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6504325b&scoped=true&"
import script from "./Header.js?vue&type=script&lang=js&"
export * from "./Header.js?vue&type=script&lang=js&"
import style0 from "./Header.css?vue&type=style&index=0&id=6504325b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504325b",
  null
  
)

export default component.exports